<template>
  <div class="relative min-h-screen">
    <section
      class="flex flex-col items-center justify-center px-4 pt-20 pb-48 text-center text-white cover"
    >
      <p class="mb-16 -mt-5 text-4xl">Edit profile</p>


      <form
        class="flex flex-col items-center w-full max-w-sm"
        @submit.prevent="handleSave"
      >
        <base-avatar v-model="avatar_id" :name="username" />
        <base-input
          v-model="name"
          v-validate="'required|max:255'"
          name="name"
          class="w-full"
          inputClass="bg-gray-500 text-white"
          placeholder="Name"
          :message="errors.first('name')"
        />

        <base-input
          v-model="username"
          v-validate="'required|min:4|max:255'"
          name="username"
          class="w-full mt-4"
          inputClass="bg-gray-500 text-white"
          placeholder="Username"
          :message="errors.first('username')"
        />

        <base-input
          v-model="email"
          v-validate="'email'"
          name="email"
          class="w-full mt-4"
          inputClass="bg-gray-500 text-white cursor-not-allowed"
          placeholder="Email"
          disabled="disabled"
          :message="errors.first('email')"
          readonly
        />

        <base-input
          v-model="phone"
          v-validate="'required'"
          v-mask="'(###) ###-####'"
          name="phone"
          class="w-full mt-4"
          inputClass="bg-gray-500 text-white"
          placeholder="Phone"
          :message="errors.first('phone')"
        />

        <base-input
          ref="password"
          v-model="password"
          v-validate="'min:8|verify_password'"
          name="password"
          class="w-full mt-4"
          inputClass="bg-gray-500 text-white"
          placeholder="Password"
          type="password"
          :message="errors.first('password')"
        />

        <base-input
          v-model="password_confirmation"
          v-validate="'confirmed:password'"
          name="password_confirmation"
          data-vv-as="password confirmation"
          class="w-full mt-4"
          inputClass="bg-gray-500 text-white"
          placeholder="Confirm password"
          type="password"
          :message="errors.first('password_confirmation')"
        />

        <div class="flex w-full my-16">
          <button
            class="btn btn-dark w-36"
            :disabled="isLoading"
            type="button"
            @click="handleLogout"
          >
            Logout
          </button>
          <button
            class="flex-grow ml-4 btn w-36"
            :disabled="isLoading"
            @click="handleSave"
          >
            Save Profile
          </button>
        </div>

        <div class="flex text-white">
          <router-link to="/terms-of-use">Terms of Use</router-link>
          <router-link to="/privacy-policy" class="ml-16"
            >Privacy Policy</router-link
          >
        </div>
      </form>
    </section>

    <base-footer class="absolute bottom-0" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      name: "",
      username: "",
      email: "",
      phone: "",
      avatar_id: "",
      password: "",
      password_confirmation: "",
      isLoading: false,
      isLoginOut: false,
    };
  },
  computed: {
    ...mapState("profile", ["user"]),
  },
  watch: {
    user: {
      immediate: true,
      handler(user) {
        this.name = user.name;
        this.username = user.username;
        this.email = user.email;
        this.phone = user.phone;
        if(user.user_avatar) this.avatar_id = user.user_avatar.id;
      },
    },
  },

  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions("profile", ["update"]),

    handleLogout() {
      this.isLoginOut = true;
      this.logout();
      window.scrollTo(0, 0);
      this.$router.push("/");
    },

    async handleSave() {
      try {
        if (this.isLoading || !(await this.$validator.validateAll())) {
          return;
        }

        if (!this.password_confirmation && this.password) {
          this.$toasted.error("Please confirm the password.");
          return;
        }

        this.isLoading = true;

        await this.update({
          name: this.name,
          username: this.username,
          email: this.email,
          phone: this.phone,
          password: this.password,
          avatar_id: this.avatar_id
        });

        this.$toasted.show("Profile updated successfully.");
      } catch (e) {
        this.$setErrorsFromLaravel(e.response.data);
      } finally {
        this.isLoading = false;
      }
    },
  },
  // async beforeRouteLeave(to, from, next) {
  //   if (this.isLoginOut) {
  //     return next();
  //   }

  //   if (!this.name || !this.username || !this.phone || !this.email) {
  //     await this.$validator.validateAll();
  //     this.$toasted.error("Please, you need to complete all the fields.");
  //     return next(false);
  //   }

  //   next();
  // },
};
</script>

<style scoped>
.cover {
  background-image: url("/images/background.jpg");
  height: calc(100% - 64px);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
